<template>
  <div>
    <div class="pd10-y">请选择需要的表头字段，并排序：</div>
    <el-alert title="【您选的表头字段会在excel上展示，同时该字段的内容会自动复制到Excel表格上】" type="warning">
    </el-alert>
    <el-checkbox v-model="checkAll" class="pd10-y" :indeterminate="isIndeterminate" @change="handleCheckAllChange"
      >全选</el-checkbox
    >
    <el-checkbox-group v-model="checked" class="mb10">
      <el-checkbox v-for="(val, index) in data" :key="index" :label="val" class="checkbox_item">{{ val }}</el-checkbox>
    </el-checkbox-group>
    <div class="mb10">拖拽即可排列表头顺序</div>
    <div id="checkedList" class="flex-row flex-wrap mb10">
      <div v-for="(val, i) in checked" :key="i" :index="i" class="mr10 mb10 checked_item">{{ val }}</div>
    </div>
    <div class="text_right">
      <el-button type="primary" size="mini" @click="$emit('confirm', checked)">确定</el-button>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  props: {
    data: { type: Array, default: () => [] },
    defaultChecked: { type: Array, default: () => [] },
  },
  data() {
    return {
      checkAll: false,
      checked: [],
      isIndeterminate: false,
    }
  },
  watch: {
    defaultChecked(newValue, oldValue) {
      this.checked = newValue
    },
  },
  mounted() {
    const sortableEl = document.getElementById('checkedList')
    this.sortable = Sortable.create(sortableEl)
  },
  methods: {
    handleCheckAllChange(val) {
      this.checked = val ? this.data : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.data.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.data.length
    },
  },
}
</script>

<style scoped>
.checkbox_item {
  width: 150px;
}
.checked_item {
  display: inline-block;
  background-color: rgb(255, 153, 0);
  padding: 5px;
  color: #fff;
  border-radius: 4px;
  border: 1px solid rgba(255, 109, 0, 0.1);
}
</style>
